module.exports = __webpack_public_path__ + "static/media/meta.ae7b6ebb.jpg";